// Declare global types for Heap
declare global {
  interface Window {
    heap: {
      load: (envId: string, config?: Record<string, any>) => void;
      track: (eventName: string, properties?: Record<string, any>) => void;
      identify: (userId: string) => void;
      addUserProperties: (traits: Record<string, any>) => void;
      trackPageview: () => void;
      [key: string]: any;
    };
    heapReadyCb: Array<{name: string, fn: () => void}>;
  }
}

const HEAP_ENV_ID = '1162356574';

export const initHeap = () => {
  // Check if heap is already loaded
  if (typeof window !== 'undefined' && !window.heap) {
    window.heapReadyCb = window.heapReadyCb || [];
    window.heap = window.heap || {} as Window['heap'];
    
    window.heap.load = function(e, t) {
      window.heap.envId = e;
      window.heap.clientConfig = t = t || {};
      window.heap.clientConfig.shouldFetchServerConfig = !1;
      
      var a = document.createElement("script");
      a.type = "text/javascript";
      a.async = !0;
      a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
      
      var r = document.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(a, r);
      
      var n = ["init", "startTracking", "stopTracking", "track", "resetIdentity",
        "identify", "getSessionId", "getUserId", "getIdentity", "addUserProperties",
        "addEventProperties", "removeEventProperty", "clearEventProperties",
        "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn",
        "onReady", "addPageviewProperties", "removePageviewProperty",
        "clearPageviewProperties", "trackPageview"];
        
      var i = function(e) {
        return function() {
          var t = Array.prototype.slice.call(arguments, 0);
          window.heapReadyCb.push({
            name: e,
            fn: function() {
              window.heap[e] && window.heap[e].apply(window.heap, t);
            }
          });
        };
      };
      
      for (var p = 0; p < n.length; p++) window.heap[n[p]] = i(n[p]);
    };
    
    window.heap.load(HEAP_ENV_ID);
  }
};

// Helper function to track events
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    if (typeof window !== 'undefined' && window.heap && typeof window.heap.track === 'function') {
      window.heap.track(eventName, properties);
    } else {
      console.warn('Heap not initialized. Event not tracked:', eventName);
    }
  } catch (error) {
    console.error('Error tracking event in Heap:', error);
  }
};

// Helper function to track page views
export const trackPageView = () => {
  try {
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);
      
      // Add page view properties
      const pageViewProperties = {
        path: currentPath,
        page_title: document.title,
        url: window.location.href,
        referrer: document.referrer,
        query_params: Object.fromEntries(searchParams.entries()),
      };
      
      // Either call trackPageview or track a custom event
      if (window.heap && typeof window.heap.trackPageview === 'function') {
        window.heap.addPageviewProperties(pageViewProperties);
        window.heap.trackPageview();
      } else {
        trackEvent('page_view', pageViewProperties);
      }
    }
  } catch (error) {
    console.error('Error tracking page view in Heap:', error);
  }
};

// Helper function to identify users
export const identifyUser = (userId: string, traits?: Record<string, any>) => {
  try {
    if (typeof window !== 'undefined' && window.heap) {
      if (typeof window.heap.identify === 'function') {
        window.heap.identify(userId);
      }
      
      if (traits && Object.keys(traits).length > 0 && typeof window.heap.addUserProperties === 'function') {
        window.heap.addUserProperties(traits);
      }
    } else {
      console.warn('Heap not initialized. User not identified:', userId);
    }
  } catch (error) {
    console.error('Error identifying user in Heap:', error);
  }
}; 